<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-6">
          <strong class="card-title mb-3">{{'Portfolio'}}</strong>
        </div>
        <div class="col-md-5"></div>
        <div class="col-md-1">
          <goback></goback>
          <!-- <div class="pull-right">
            <router-link class="btn btn-sm" :to="'/mutual-funds/rawdata'"><i class="fa fa-caret-left"></i> Go Back</router-link>
          </div>-->
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-6">
          <div class="form-group">
            <v-select
              :options="schemeList"
              :placeholder="'Select Scheme'"
              :label="'name'"
              v-model="selScheme1"
              multiple
            ></v-select>
          </div>
        </div>
        <div class="col-md-6">
          <button class="btn btn-primary" @click="filterSchemes()">Filter</button>
          <button class="btn btn-danger" @click="resetFilter()">Reset</button>
        </div>
      </div>
      <div class="row mb5"></div>

      <!--- Pagination ---------->
      <div class="row">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <div class="pull-right">
            <ul v-if="totalPages != 1" class="pagination">
              <li :class="{disabled:prevDisabled}" class="page-item">
                <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
              </li>
              <li :class="{disabled:prevDisabled}" class="page-item">
                <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
              </li>
              <li
                v-for="page in pages"
                v-bind:key="page"
                class="page-item"
                :class="(current_page == page)? 'active':''"
              >
                <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
              </li>
              <li :class="{disabled:nextDisabled}" class="page-item">
                <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
              </li>
              <li :class="{disabled:nextDisabled}" class="page-item">
                <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--- END Pagination ---------->

      <div v-if="selScheme1.length > 0 && isFiltered && isApiCalled == 0">
        <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
          <div class="row my-2">
            <div class="col-md-6">
              <h4 class="">Consolidated Holdings</h4>
            </div>
            <div class="col-md-6">
              <div class="text-right" >
                  <download :tableId="'consolidatedHoldings'" :fileName="'consolidatedHoldings'"></download>
              </div>
            </div>
          </div>
          <table
              :id="'consolidatedHoldings'"
              class="table table-bordered fonts11 app-inner"
              v-if="tableFields.length > 0"
            >
            <thead>
              <tr>
                <th>Sr.</th>
                <th
                  class="data-cell"
                  v-for="(field, index, key) in tableFields"
                  v-bind:key="'field'+field.rowind+index+key"
                >{{field.name}}</th>
                <th v-if="actions.length">Actions</th>
                <th
                  v-for="(field, index) in ratings.subFields"
                  v-bind:key="'ratingsth'+ field.title+index"
                >
                  {{field.name}}
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort == 1 || field.sort == 0)"
                  ></i>
                  <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tr, ind) in consolidatedHoldingsList" v-bind:key="'trBod'+'-'+ind">
                <td>
                  <span>{{ind+1}}</span>
                </td>
                <td v-for="(cl, index) in tableFields" v-bind:key="index+'cldata'+cl.title">
                  <span v-if="cl.isLink">
                    <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                    <router-link
                      class="a-btn"
                      :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                      target="_blank"
                    >{{tr[cl.title]}}</router-link>
                  </span>
                  <span v-else>
                    <span v-if="cl.datatype=='date'">{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                    <span v-else-if="cl.datatype=='numeric'">{{getChecknFixed(tr[cl.title])}}</span>
                    <span v-else-if="cl.datatype=='rating'">
                      <star-rating
                        v-bind:increment="0.5"
                        v-bind:max-rating="(cl.title=='p11_rating')? 7:5"
                        :rating="parseInt(tr[cl.title])"
                        :read-only="true"
                        :show-rating="false"
                        inactive-color="#868e96"
                        active-color="#ffbf00"
                        v-bind:star-size="20"
                      ></star-rating>
                    </span>
                    <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                  </span>
                </td>
                <td v-if="actions.length">
                  <div
                    class="action-btn-wrapper"
                    v-for="action in actions"
                    v-bind:key="'action'+action.tooltip"
                  >
                    <span v-if="action.isLink">
                      <router-link
                        style="margin:1px 4px"
                        class="a-btn"
                        :class="action.btnClass"
                        :to="action.url+tr[action.param]"
                        :target="action.isNewWindow? '_blank': ''"
                        :title="action.tooltip"
                      >{{action.tooltip}}</router-link>
                    </span>
                    <span v-else>
                      <a
                        style="margin:1px 4px"
                        class="a-btn"
                        :class="action.btnClass"
                        @click.prevent="action.callback(tr['mf_schcode'])"
                        :title="action.tooltip"
                      >{{action.tooltip}}</a>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mb5" v-if="consolidatedHoldingsList.length <= 0">
          <div class="col-md-12">
            <div class="alert alert-danger" role="alert">No data found!</div>
          </div>
        </div>

        <!------CREDIT RATINGS-------->
        <div class="row">
          <div class="col-md-12">
            <!--  Typewise Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-6">
                  <h4 class="">Credit Rating Wise Data</h4>
                </div>
                <div class="col-md-6">
                  <div class="text-right" >
                      <download :tableId="'creditratingData'" :fileName="'creditratingData'"></download>
                  </div>
                </div>
              </div>
              <table :id="'creditratingData'" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr><th v-for="(cr, ind) in creditRatingsKeys" v-bind:key="'crth'+ind">{{cr.name}}</th></tr>
                </thead>
                <tbody>
                  <tr v-for="(crData, ind1) in rawData.consolidated_portfolio_figures.credit_ratings_wise" v-bind:key="'crtr'+ind1">
                      <td v-for="(cr, ind) in creditRatingsKeys" v-bind:key="'crtd'+ind">
                        <span v-if="((rawData.consolidated_portfolio_figures.credit_ratings_wise).length - 1) == ind1">
                          <strong>
                            <span v-if="cr.datatype == 'numeric'">
                              {{(crData[cr.title] != 'undefined')? getFixed(crData[cr.title]): ''}}
                            </span>
                            <span v-else>{{crData[cr.title]}}</span>
                          </strong>
                        </span>
                        <span v-else>
                          <span v-if="cr.datatype == 'numeric'">
                            {{(crData[cr.title] != 'undefined')? getFixed(crData[cr.title]): ''}}
                          </span>
                          <span v-else>{{crData[cr.title]}}</span>
                        </span>
                      </td>
                    </tr>
                    <!-- <tr>
                      <td v-for="(cr, tdInd) in creditRatingsKeys" :key="tdInd + 'crtotal'">
                        <span v-if="cr.title == 'name'"><b>Total</b></span>
                        <span v-else-if="cr.title == 'type'"><b></b></span>
                        <span v-else-if="cr.title != 'type' && cr.title != 'name'"><b> {{ getFixed(rawData.holdings_summary['totals']['credit_ratings'][cr.title])  }} </b></span>
                        <span v-else>-</span>
                      </td>
                    </tr> -->
                </tbody>
              </table>
            </div>
            <div class="row mb5" v-if="rawData.consolidated_portfolio_figures.credit_ratings_wise && !rawData.consolidated_portfolio_figures.credit_ratings_wise.length">
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <!-- // Company Wise Data Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-6">
                  <h4 class="">Company Wise Data</h4>
                </div>
                <div class="col-md-6">
                  <div class="text-right" >
                      <download :tableId="'CompanyData'" :fileName="'CompanyData'"></download>
                  </div>
                </div>
              </div>
              <table :id="'CompanyData'" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in companywiseTableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >{{field.name}}</th>
                    <th v-if="actions.length">Actions</th>
                    <th
                      v-for="(field, index) in ratings.subFields"
                      v-bind:key="'ratingsth'+ field.title+index"
                    >
                      {{field.name}}
                      <i
                        class="fa fa-caret-down"
                        v-if="(field.sort == 1 || field.sort == 0)"
                      ></i>
                      <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, ind) in consolidated_portfolio_figures.companywise.figures"
                    v-bind:key="'trBod'+'-'+ind"
                  >
                    <td>
                      <span v-if="rawDataType=='schemes'">
                        <span v-if="page>1">{{(perPage * (page-1)) + (ind+1)}}</span>
                        <span v-else>{{ind+1}}</span>
                      </span>
                      <span v-else>{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in companywiseTableFields"
                      v-bind:key="index+'cldata'+cl.title"
                    >
                      <span v-if="cl.isLink">
                        <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                        <router-link
                          class="a-btn"
                          :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                          target="_blank"
                        >{{tr[cl.title]}}</router-link>
                      </span>
                      <span v-else>
                        <span
                          v-if="cl.datatype=='date'"
                        >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                        <span v-else-if="cl.datatype=='numeric'">{{getChecknFixed(tr[cl.title])}}</span>
                        <span v-else-if="cl.datatype=='rating'">
                          <star-rating
                            v-bind:increment="0.5"
                            v-bind:max-rating="(cl.title=='p11_rating')? 7:5"
                            :rating="parseInt(tr[cl.title])"
                            :read-only="true"
                            :show-rating="false"
                            inactive-color="#868e96"
                            active-color="#ffbf00"
                            v-bind:star-size="20"
                          ></star-rating>
                        </span>
                        <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                      </span>
                    </td>
                    <td v-if="actions.length">
                      <div
                        class="action-btn-wrapper"
                        v-for="action in actions"
                        v-bind:key="'action'+action.tooltip"
                      >
                        <span v-if="action.isLink">
                          <router-link
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            :to="action.url+tr[action.param]"
                            :target="action.isNewWindow? '_blank': ''"
                            :title="action.tooltip"
                          >{{action.tooltip}}</router-link>
                        </span>
                        <span v-else>
                          <a
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            @click.prevent="action.callback(tr['mf_schcode'])"
                            :title="action.tooltip"
                          >{{action.tooltip}}</a>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="consolidated_portfolio_figures.companywise.figures.length > 0">
                    <td class="text-center" colspan="2">Total</td>
                    <td>{{getChecknFixed(consolidated_portfolio_figures.companywise.total)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="row mb5"
              v-if="consolidated_portfolio_figures.companywise.figures.length <= 0"
            >
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!-- // SectorWise Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-6">
                  <h4 class="">Industry Wise Data</h4>
                </div>
                <div class="col-md-6">
                  <div class="text-right" >
                      <download :tableId="'SectorData'" :fileName="'SectorData'"></download>
                  </div>
                </div>
              </div>
              <table :id="'SectorData'" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in sectorwiseTableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >{{field.name}}</th>
                    <th v-if="actions.length">Actions</th>
                    <th
                      v-for="(field, index) in ratings.subFields"
                      v-bind:key="'ratingsth'+ field.title+index"
                    >
                      {{field.name}}
                      <i
                        class="fa fa-caret-down"
                        v-if="(field.sort == 1 || field.sort == 0)"
                      ></i>
                      <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, ind) in consolidated_portfolio_figures.sectorwise.figures"
                    v-bind:key="'trBod'+'-'+ind"
                  >
                    <td>
                      <span v-if="rawDataType=='schemes'">
                        <span v-if="page>1">{{(perPage * (page-1)) + (ind+1)}}</span>
                        <span v-else>{{ind+1}}</span>
                      </span>
                      <span v-else>{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in sectorwiseTableFields"
                      v-bind:key="index+'cldata'+cl.title"
                    >
                      <span v-if="cl.isLink">
                        <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                        <router-link
                          class="a-btn"
                          :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                          target="_blank"
                        >{{tr[cl.title]}}</router-link>
                      </span>
                      <span v-else>
                        <span
                          v-if="cl.datatype=='date'"
                        >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                        <span v-else-if="cl.datatype=='numeric'">{{getChecknFixed(tr[cl.title])}}</span>
                        <span v-else-if="cl.datatype=='rating'">
                          <star-rating
                            v-bind:increment="0.5"
                            v-bind:max-rating="(cl.title=='p11_rating')? 7:5"
                            :rating="parseInt(tr[cl.title])"
                            :read-only="true"
                            :show-rating="false"
                            inactive-color="#868e96"
                            active-color="#ffbf00"
                            v-bind:star-size="20"
                          ></star-rating>
                        </span>
                        <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                      </span>
                    </td>
                    <td v-if="actions.length">
                      <div
                        class="action-btn-wrapper"
                        v-for="action in actions"
                        v-bind:key="'action'+action.tooltip"
                      >
                        <span v-if="action.isLink">
                          <router-link
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            :to="action.url+tr[action.param]"
                            :target="action.isNewWindow? '_blank': ''"
                            :title="action.tooltip"
                          >{{action.tooltip}}</router-link>
                        </span>
                        <span v-else>
                          <a
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            @click.prevent="action.callback(tr['mf_schcode'])"
                            :title="action.tooltip"
                          >{{action.tooltip}}</a>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="consolidated_portfolio_figures.sectorwise.figures.length > 0">
                    <td class="text-center" colspan="2">Total</td>
                    <td>{{getChecknFixed(consolidated_portfolio_figures.sectorwise.total)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="row mb5"
              v-if="consolidated_portfolio_figures.sectorwise.figures.length <= 0"
            >
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
          </div>
        </div>
        <!--  MCapType Table -->
        <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
          <div class="row my-2">
            <div class="col-md-6">
              <h4 class="">McapType Wise Data</h4>
            </div>
            <div class="col-md-6">
              <div class="text-right" >
                  <download :tableId="'McapTypeData'" :fileName="'McapTypeData'"></download>
              </div>
            </div>
          </div>
          <table :id="'McapTypeData'" class="table table-bordered fonts11 app-inner">
            <thead>
              <tr>
                <th>Sr.</th>
                <th
                  class="data-cell"
                  v-for="(field, index, key) in mcaptypewiseTableFields"
                  v-bind:key="'field'+field.rowind+index+key"
                >{{field.name}}</th>
                <th v-if="actions.length">Actions</th>
                <th
                  v-for="(field, index) in ratings.subFields"
                  v-bind:key="'ratingsth'+ field.title+index"
                >
                  {{field.name}}
                  <i
                    class="fa fa-caret-down"
                    v-if="(field.sort == 1 || field.sort == 0)"
                  ></i>
                  <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(tr, ind) in consolidated_portfolio_figures.mcaptypewise.figures"
                v-bind:key="'trBod'+'-'+ind"
              >
                <td>
                  <span v-if="rawDataType=='schemes'">
                    <span v-if="page>1">{{(perPage * (page-1)) + (ind+1)}}</span>
                    <span v-else>{{ind+1}}</span>
                  </span>
                  <span v-else>{{ind+1}}</span>
                </td>
                <td
                  v-for="(cl, index) in mcaptypewiseTableFields"
                  v-bind:key="index+'cldata'+cl.title"
                >
                  <span v-if="cl.isLink">
                    <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                    <router-link
                      class="a-btn"
                      :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                      target="_blank"
                    >{{tr[cl.title]}}</router-link>
                  </span>
                  <span v-else>
                    <span v-if="cl.datatype=='date'">{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                    <span v-else-if="cl.datatype=='numeric'">{{getChecknFixed(tr[cl.title])}}</span>
                    <span v-else-if="cl.datatype=='rating'">
                      <star-rating
                        v-bind:increment="0.5"
                        v-bind:max-rating="(cl.title=='p11_rating')? 7:5"
                        :rating="parseInt(tr[cl.title])"
                        :read-only="true"
                        :show-rating="false"
                        inactive-color="#868e96"
                        active-color="#ffbf00"
                        v-bind:star-size="20"
                      ></star-rating>
                    </span>
                    <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                  </span>
                </td>
                <td v-if="actions.length">
                  <div
                    class="action-btn-wrapper"
                    v-for="action in actions"
                    v-bind:key="'action'+action.tooltip"
                  >
                    <span v-if="action.isLink">
                      <router-link
                        style="margin:1px 4px"
                        class="a-btn"
                        :class="action.btnClass"
                        :to="action.url+tr[action.param]"
                        :target="action.isNewWindow? '_blank': ''"
                        :title="action.tooltip"
                      >{{action.tooltip}}</router-link>
                    </span>
                    <span v-else>
                      <a
                        style="margin:1px 4px"
                        class="a-btn"
                        :class="action.btnClass"
                        @click.prevent="action.callback(tr['mf_schcode'])"
                        :title="action.tooltip"
                      >{{action.tooltip}}</a>
                    </span>
                  </div>
                </td>
              </tr>
              <tr v-if="consolidated_portfolio_figures.mcaptypewise.figures.length > 0">
                <td class="text-center" colspan="2">Total</td>
                <td>{{getChecknFixed(consolidated_portfolio_figures.mcaptypewise.total)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row mb5" v-if="consolidated_portfolio_figures.mcaptypewise.figures.length <= 0">
          <div class="col-md-12">
            <div class="alert alert-danger" role="alert">No data found!</div>
          </div>
        </div>

        <!-- <div v-for="(item, key, index) in consolidated_top_3_exposures" :key="'top3-'+index">
          {{ key  }}
        </div> -->
         <div class="row">
          <div class="col-md-6" v-for="(item, consolidatedTypeKey, index) in consolidated_top_3_exposures" :key="'top3-'+index">
            <!--  Business Ratingwise Holdings Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-10">
                  <h4 class=""> {{ item.tableHeading }} </h4>
                </div>
                <div class="col-md-2">
                  <div class="text-right" >
                      <download :tableId="item.tableHeading" :fileName="item.tableHeading"></download>
                  </div>
                </div>
              </div>
              <table :id="item.tableHeading" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in getTableFieldByType(consolidatedTypeKey)"
                      v-bind:key="'field'+field.rowind+index+key"
                    >{{field.name}}</th>
                    <th v-if="actions.length">Actions</th>
                    <th
                      v-for="(field, index) in ratings.subFields"
                      v-bind:key="'ratingsth'+ field.title+index"
                    >
                      {{field.name}}
                      <i
                        class="fa fa-caret-down"
                        v-if="(field.sort == 1 || field.sort == 0)"
                      ></i>
                      <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, ind) in consolidated_top_3_exposures[consolidatedTypeKey].figures"
                    v-bind:key="consolidatedTypeKey+'-'+ind"
                  >
                    <td>
                      <span >{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in getTableFieldByType(consolidatedTypeKey)"
                      v-bind:key="index+'bussdata'+cl.title"
                    >
                      <span v-if="cl.isLink">
                        <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                        <router-link
                          class="a-btn"
                          :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                          target="_blank"
                        >{{tr[cl.title]}}</router-link>
                      </span>
                      <span v-else>
                        <span
                          v-if="cl.datatype=='date'"
                        >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                        <span v-else-if="cl.datatype=='numeric'"> 
                           {{getChecknFixed(tr[cl.title])}}
                        </span>
                        <span v-else-if="cl.datatype=='rating'">
                          <star-rating
                            v-bind:increment="0.5"
                            v-bind:max-rating="7"
                            :rating="parseInt(tr[cl.title])"
                            :read-only="true"
                            :show-rating="false"
                            inactive-color="#868e96"
                            active-color="#ffbf00"
                            v-bind:star-size="20"
                          ></star-rating>
                        </span>
                        <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                      </span>
                    </td>
                    <td v-if="actions.length">
                      <div
                        class="action-btn-wrapper"
                        v-for="action in actions"
                        v-bind:key="'action'+action.tooltip"
                      >
                        <span v-if="action.isLink">
                          <router-link
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            :to="action.url+tr[action.param]"
                            :target="action.isNewWindow? '_blank': ''"
                            :title="action.tooltip"
                          >{{action.tooltip}}</router-link>
                        </span>
                        <span v-else>
                          <a
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            @click.prevent="action.callback(tr['mf_schcode'])"
                            :title="action.tooltip"
                          >{{action.tooltip}}</a>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="consolidated_top_3_exposures[consolidatedTypeKey].figures.length > 0">
                    <td class="text-center" colspan="2">Total</td>
                    <td>{{getChecknFixed(consolidated_top_3_exposures[consolidatedTypeKey].total)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="row mb5"
              v-if="consolidated_top_3_exposures[consolidatedTypeKey].figures.length <= 0"
            >
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <!--  Business Ratingwise Holdings Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-10">
                  <h4 class="">Business Ratingwise Holdings</h4>
                </div>
                <div class="col-md-2">
                  <div class="text-right" >
                      <download :tableId="'BusinessRatingData'" :fileName="'BusinessRatingData'"></download>
                  </div>
                </div>
              </div>
              <table :id="'BusinessRatingData'" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in businessRatingTableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >{{field.name}}</th>
                    <th v-if="actions.length">Actions</th>
                    <th
                      v-for="(field, index) in ratings.subFields"
                      v-bind:key="'ratingsth'+ field.title+index"
                    >
                      {{field.name}}
                      <i
                        class="fa fa-caret-down"
                        v-if="(field.sort == 1 || field.sort == 0)"
                      ></i>
                      <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, ind) in consolidated_portfolio_figures.business_rating.figures"
                    v-bind:key="'trBussRating'+'-'+ind"
                  >
                    <td>
                      <span >{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in businessRatingTableFields"
                      v-bind:key="index+'bussdata'+cl.title"
                    >
                      <span v-if="cl.isLink">
                        <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                        <router-link
                          class="a-btn"
                          :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                          target="_blank"
                        >{{tr[cl.title]}}</router-link>
                      </span>
                      <span v-else>
                        <span
                          v-if="cl.datatype=='date'"
                        >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                        <span v-else-if="cl.datatype=='numeric'"> 
                           {{getChecknFixed(tr[cl.title])}}
                        </span>
                        <span v-else-if="cl.datatype=='rating'">
                          <star-rating
                            v-bind:increment="0.5"
                            v-bind:max-rating="7"
                            :rating="parseInt(tr[cl.title])"
                            :read-only="true"
                            :show-rating="false"
                            inactive-color="#868e96"
                            active-color="#ffbf00"
                            v-bind:star-size="20"
                          ></star-rating>
                        </span>
                        <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                      </span>
                    </td>
                    <td v-if="actions.length">
                      <div
                        class="action-btn-wrapper"
                        v-for="action in actions"
                        v-bind:key="'action'+action.tooltip"
                      >
                        <span v-if="action.isLink">
                          <router-link
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            :to="action.url+tr[action.param]"
                            :target="action.isNewWindow? '_blank': ''"
                            :title="action.tooltip"
                          >{{action.tooltip}}</router-link>
                        </span>
                        <span v-else>
                          <a
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            @click.prevent="action.callback(tr['mf_schcode'])"
                            :title="action.tooltip"
                          >{{action.tooltip}}</a>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="consolidated_portfolio_figures.business_rating.figures.length > 0">
                    <td class="text-center" colspan="2">Total</td>
                    <td>{{getChecknFixed(consolidated_portfolio_figures.business_rating.total)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="row mb5"
              v-if="consolidated_portfolio_figures.business_rating.figures.length <= 0"
            >
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!--  Debt Ratingwise Holdings Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-10">
                  <h4 class="">Debt Ratingwise Holdings</h4>
                </div>
                <div class="col-md-2">
                  <div class="text-right" >
                      <download :tableId="'DebtRatingData'" :fileName="'DebtRatingData'"></download>
                  </div>
                </div>
              </div>
              <table :id="'DebtRatingData'" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in debtRatingTableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >{{field.name}}</th>
                    <th v-if="actions.length">Actions</th>
                    <th
                      v-for="(field, index) in ratings.subFields"
                      v-bind:key="'ratingsth'+ field.title+index"
                    >
                      {{field.name}}
                      <i
                        class="fa fa-caret-down"
                        v-if="(field.sort == 1 || field.sort == 0)"
                      ></i>
                      <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, ind) in consolidated_portfolio_figures.debt_rating.figures"
                    v-bind:key="'trDebtRating'+'-'+ind"
                  >
                    <td>
                      <span >{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in debtRatingTableFields"
                      v-bind:key="index+'debtdata'+cl.title"
                    >
                      <span v-if="cl.isLink">
                        <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                        <router-link
                          class="a-btn"
                          :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                          target="_blank"
                        >{{tr[cl.title]}}</router-link>
                      </span>
                      <span v-else>
                        <span
                          v-if="cl.datatype=='date'"
                        >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                        <span v-else-if="cl.datatype=='numeric'"> 
                           {{getChecknFixed(tr[cl.title])}}
                        </span>
                        <span v-else-if="cl.datatype=='rating'">
                          <star-rating
                            v-bind:increment="0.5"
                            v-bind:max-rating="7"
                            :rating="parseInt(tr[cl.title])"
                            :read-only="true"
                            :show-rating="false"
                            inactive-color="#868e96"
                            active-color="#ffbf00"
                            v-bind:star-size="20"
                          ></star-rating>
                        </span>
                        <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                      </span>
                    </td>
                    <td v-if="actions.length">
                      <div
                        class="action-btn-wrapper"
                        v-for="action in actions"
                        v-bind:key="'action'+action.tooltip"
                      >
                        <span v-if="action.isLink">
                          <router-link
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            :to="action.url+tr[action.param]"
                            :target="action.isNewWindow? '_blank': ''"
                            :title="action.tooltip"
                          >{{action.tooltip}}</router-link>
                        </span>
                        <span v-else>
                          <a
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            @click.prevent="action.callback(tr['mf_schcode'])"
                            :title="action.tooltip"
                          >{{action.tooltip}}</a>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="consolidated_portfolio_figures.debt_rating.figures.length > 0">
                    <td class="text-center" colspan="2">Total</td>
                    <td>{{getChecknFixed(consolidated_portfolio_figures.debt_rating.total)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="row mb5"
              v-if="consolidated_portfolio_figures.debt_rating.figures.length <= 0"
            >
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
          </div>
        </div>

         <div class="row">
          <div class="col-md-6">
            <!--  Valuation Ratingwise Holdings Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-10">
                  <h4 class="">Valuation Ratingwise Holdings</h4>
                </div>
                <div class="col-md-2">
                  <div class="text-right" >
                      <download :tableId="'ValuationRatingData'" :fileName="'ValuationRatingData'"></download>
                  </div>
                </div>
              </div>
              <table :id="'ValuationRatingData'" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in valuationRatingTableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >{{field.name}}</th>
                    <th v-if="actions.length">Actions</th>
                    <th
                      v-for="(field, index) in ratings.subFields"
                      v-bind:key="'ratingsth'+ field.title+index"
                    >
                      {{field.name}}
                      <i
                        class="fa fa-caret-down"
                        v-if="(field.sort == 1 || field.sort == 0)"
                      ></i>
                      <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, ind) in consolidated_portfolio_figures.valuation_rating.figures"
                    v-bind:key="'trBussRating'+'-'+ind"
                  >
                    <td>
                      <span >{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in valuationRatingTableFields"
                      v-bind:key="index+'bussdata'+cl.title"
                    >
                      <span v-if="cl.isLink">
                        <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                        <router-link
                          class="a-btn"
                          :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                          target="_blank"
                        >{{tr[cl.title]}}</router-link>
                      </span>
                      <span v-else>
                        <span
                          v-if="cl.datatype=='date'"
                        >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                        <span v-else-if="cl.datatype=='numeric'"> 
                           {{getChecknFixed(tr[cl.title])}}
                        </span>
                        <span v-else-if="cl.datatype=='rating'">
                          <star-rating
                            v-bind:increment="0.5"
                            v-bind:max-rating="7"
                            :rating="parseInt(tr[cl.title])"
                            :read-only="true"
                            :show-rating="false"
                            inactive-color="#868e96"
                            active-color="#ffbf00"
                            v-bind:star-size="20"
                          ></star-rating>
                        </span>
                        <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                      </span>
                    </td>
                    <td v-if="actions.length">
                      <div
                        class="action-btn-wrapper"
                        v-for="action in actions"
                        v-bind:key="'action'+action.tooltip"
                      >
                        <span v-if="action.isLink">
                          <router-link
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            :to="action.url+tr[action.param]"
                            :target="action.isNewWindow? '_blank': ''"
                            :title="action.tooltip"
                          >{{action.tooltip}}</router-link>
                        </span>
                        <span v-else>
                          <a
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            @click.prevent="action.callback(tr['mf_schcode'])"
                            :title="action.tooltip"
                          >{{action.tooltip}}</a>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="consolidated_portfolio_figures.valuation_rating.figures.length > 0">
                    <td class="text-center" colspan="2">Total</td>
                    <td>{{getChecknFixed(consolidated_portfolio_figures.valuation_rating.total)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="row mb5"
              v-if="consolidated_portfolio_figures.valuation_rating.figures.length <= 0"
            >
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!--  Quarterly Ratingwise Holdings Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-10">
                  <h4 class="">Quarterly Ratingwise Holdings</h4>
                </div>
                <div class="col-md-2">
                  <div class="text-right" >
                      <download :tableId="'QuarterlyRatingData'" :fileName="'QuarterlyRatingData'"></download>
                  </div>
                </div>
              </div>
              <table :id="'QuarterlyRatingData'" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in quarterlyRatingTableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >{{field.name}}</th>
                    <th v-if="actions.length">Actions</th>
                    <th
                      v-for="(field, index) in ratings.subFields"
                      v-bind:key="'ratingsth'+ field.title+index"
                    >
                      {{field.name}}
                      <i
                        class="fa fa-caret-down"
                        v-if="(field.sort == 1 || field.sort == 0)"
                      ></i>
                      <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, ind) in consolidated_portfolio_figures.quarterly_rating.figures"
                    v-bind:key="'trDebtRating'+'-'+ind"
                  >
                    <td>
                      <span >{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in quarterlyRatingTableFields"
                      v-bind:key="index+'debtdata'+cl.title"
                    >
                      <span v-if="cl.isLink">
                        <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                        <router-link
                          class="a-btn"
                          :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                          target="_blank"
                        >{{tr[cl.title]}}</router-link>
                      </span>
                      <span v-else>
                        <span
                          v-if="cl.datatype=='date'"
                        >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                        <span v-else-if="cl.datatype=='numeric'"> 
                           {{getChecknFixed(tr[cl.title])}}
                        </span>
                        <span v-else-if="cl.datatype=='rating'">
                          <star-rating
                            v-bind:increment="0.5"
                            v-bind:max-rating="7"
                            :rating="parseInt(tr[cl.title])"
                            :read-only="true"
                            :show-rating="false"
                            inactive-color="#868e96"
                            active-color="#ffbf00"
                            v-bind:star-size="20"
                          ></star-rating>
                        </span>
                        <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                      </span>
                    </td>
                    <td v-if="actions.length">
                      <div
                        class="action-btn-wrapper"
                        v-for="action in actions"
                        v-bind:key="'action'+action.tooltip"
                      >
                        <span v-if="action.isLink">
                          <router-link
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            :to="action.url+tr[action.param]"
                            :target="action.isNewWindow? '_blank': ''"
                            :title="action.tooltip"
                          >{{action.tooltip}}</router-link>
                        </span>
                        <span v-else>
                          <a
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            @click.prevent="action.callback(tr['mf_schcode'])"
                            :title="action.tooltip"
                          >{{action.tooltip}}</a>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="consolidated_portfolio_figures.quarterly_rating.figures.length > 0">
                    <td class="text-center" colspan="2">Total</td>
                    <td>{{getChecknFixed(consolidated_portfolio_figures.quarterly_rating.total)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="row mb5"
              v-if="consolidated_portfolio_figures.quarterly_rating.figures.length <= 0"
            >
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <!--  Overall Ratingwise Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-6">
                  <h4 class="">Overall Ratings</h4>
                </div>
                <div class="col-md-6">
                  <div class="text-right" >
                      <download :tableId="'OverallRatingData'" :fileName="'ROverallRatingData'"></download>
                  </div>
                </div>
              </div>
              <table :id="'OverallRatingData'" class="table table-bordered fonts11 app-inner" v-if="rawData && rawData.consolidated_portfolio_figures && rawData.consolidated_portfolio_figures.overall_ratings">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th>Type</th>
                    <th>Rating</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(cl, ind) in overAllratingKeys"
                    v-bind:key="'trBod'+'-'+ind"
                  >
                    <td>{{ind+1}}</td>
                    <td>{{cl.name}}</td>
                    <td>
                      <span>
                        <star-rating
                          v-bind:increment="0.5"
                          v-bind:max-rating="(cl.title=='overall_business_rating' || cl.title=='overall_debt_others_rating' || cl.title == 'overall_equity_rating')? 7:5"
                          :rating="parseInt(rawData.consolidated_portfolio_figures.overall_ratings.number[cl.title])"
                          :read-only="true"
                          :show-rating="false"
                          inactive-color="#868e96"
                          active-color="#ffbf00"
                          v-bind:star-size="20"
                        ></star-rating>
                      </span>
                    </td>
                    <td>
                      <span>{{(rawData.consolidated_portfolio_figures.overall_ratings.raw[cl.title])? getChecknFixed(rawData.consolidated_portfolio_figures.overall_ratings.raw[cl.title]): '-'}}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <!--  Ratingwise Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-6">
                  <h4 class="">Rating Wise Data</h4>
                </div>
                <div class="col-md-6">
                  <div class="text-right" >
                      <download :tableId="'RatingData'" :fileName="'RatingData'"></download>
                  </div>
                </div>
              </div>
              <table :id="'RatingData'" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in ratingwiseTableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >{{field.name}}</th>
                    <th v-if="actions.length">Actions</th>
                    <th
                      v-for="(field, index) in ratings.subFields"
                      v-bind:key="'ratingsth'+ field.title+index"
                    >
                      {{field.name}}
                      <i
                        class="fa fa-caret-down"
                        v-if="(field.sort == 1 || field.sort == 0)"
                      ></i>
                      <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, ind) in consolidated_portfolio_figures.ratingwise.figures"
                    v-bind:key="'trBod'+'-'+ind"
                  >
                    <td>
                      <span v-if="rawDataType=='schemes'">
                        <span v-if="page>1">{{(perPage * (page-1)) + (ind+1)}}</span>
                        <span v-else>{{ind+1}}</span>
                      </span>
                      <span v-else>{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in ratingwiseTableFields"
                      v-bind:key="index+'cldata'+cl.title"
                    >
                      <span v-if="cl.isLink">
                        <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                        <router-link
                          class="a-btn"
                          :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                          target="_blank"
                        >{{tr[cl.title]}}</router-link>
                      </span>
                      <span v-else>
                        <span
                          v-if="cl.datatype=='date'"
                        >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                        <span v-else-if="cl.datatype=='numeric'">{{getChecknFixed(tr[cl.title])}}</span>
                        <span v-else-if="cl.datatype=='rating'">
                          <star-rating
                            v-bind:increment="0.5"
                            v-bind:max-rating="(cl.title=='p11_rating')? 7:5"
                            :rating="parseInt(tr[cl.title])"
                            :read-only="true"
                            :show-rating="false"
                            inactive-color="#868e96"
                            active-color="#ffbf00"
                            v-bind:star-size="20"
                          ></star-rating>
                        </span>
                        <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                      </span>
                    </td>
                    <td v-if="actions.length">
                      <div
                        class="action-btn-wrapper"
                        v-for="action in actions"
                        v-bind:key="'action'+action.tooltip"
                      >
                        <span v-if="action.isLink">
                          <router-link
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            :to="action.url+tr[action.param]"
                            :target="action.isNewWindow? '_blank': ''"
                            :title="action.tooltip"
                          >{{action.tooltip}}</router-link>
                        </span>
                        <span v-else>
                          <a
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            @click.prevent="action.callback(tr['mf_schcode'])"
                            :title="action.tooltip"
                          >{{action.tooltip}}</a>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="consolidated_portfolio_figures.ratingwise.figures.length > 0">
                    <td class="text-center" colspan="2">Total</td>
                    <td>{{getChecknFixed(consolidated_portfolio_figures.ratingwise.total)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="row mb5"
              v-if="consolidated_portfolio_figures.ratingwise.figures.length <= 0"
            >
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!--  Typewise Table -->
            <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
              <div class="row my-2">
                <div class="col-md-6">
                  <h4 class="">Type Wise Data</h4>
                </div>
                <div class="col-md-6">
                  <div class="text-right" >
                      <download :tableId="'TypeData'" :fileName="'TypeData'"></download>
                  </div>
                </div>
              </div>
              <table :id="'TypeData'" class="table table-bordered fonts11 app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th
                      class="data-cell"
                      v-for="(field, index, key) in typewiseTableFields"
                      v-bind:key="'field'+field.rowind+index+key"
                    >{{field.name}}</th>
                    <th v-if="actions.length">Actions</th>
                    <th
                      v-for="(field, index) in ratings.subFields"
                      v-bind:key="'ratingsth'+ field.title+index"
                    >
                      {{field.name}}
                      <i
                        class="fa fa-caret-down"
                        v-if="(field.sort == 1 || field.sort == 0)"
                      ></i>
                      <i class="fa fa-caret-up" v-else-if="(field.sort == 2 || field.sort == 0)"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tr, ind) in consolidated_portfolio_figures.typewise.figures"
                    v-bind:key="'trBod'+'-'+ind"
                  >
                    <td>
                      <span v-if="rawDataType=='schemes'">
                        <span v-if="page>1">{{(perPage * (page-1)) + (ind+1)}}</span>
                        <span v-else>{{ind+1}}</span>
                      </span>
                      <span v-else>{{ind+1}}</span>
                    </td>
                    <td
                      v-for="(cl, index) in typewiseTableFields"
                      v-bind:key="index+'cldata'+cl.title"
                    >
                      <span v-if="cl.isLink">
                        <!-- <a class="a-btn" @click.prevent="showSchemeHoldings(tr[cl.title])">{{tr[cl.title]}}</a> -->
                        <router-link
                          class="a-btn"
                          :to="'/mutual-funds/schemeholdings/' + tr[cl.title]"
                          target="_blank"
                        >{{tr[cl.title]}}</router-link>
                      </span>
                      <span v-else>
                        <span
                          v-if="cl.datatype=='date'"
                        >{{(tr[cl.title])? getDate(tr[cl.title]): '-'}}</span>
                        <span v-else-if="cl.datatype=='numeric'">{{getChecknFixed(tr[cl.title])}}</span>
                        <span v-else-if="cl.datatype=='rating'">
                          <star-rating
                            v-bind:increment="0.5"
                            v-bind:max-rating="(cl.title=='p11_rating')? 7:5"
                            :rating="parseInt(tr[cl.title])"
                            :read-only="true"
                            :show-rating="false"
                            inactive-color="#868e96"
                            active-color="#ffbf00"
                            v-bind:star-size="20"
                          ></star-rating>
                        </span>
                        <span v-else>{{(tr[cl.title])? (tr[cl.title]): '-'}}</span>
                      </span>
                    </td>
                    <td v-if="actions.length">
                      <div
                        class="action-btn-wrapper"
                        v-for="action in actions"
                        v-bind:key="'action'+action.tooltip"
                      >
                        <span v-if="action.isLink">
                          <router-link
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            :to="action.url+tr[action.param]"
                            :target="action.isNewWindow? '_blank': ''"
                            :title="action.tooltip"
                          >{{action.tooltip}}</router-link>
                        </span>
                        <span v-else>
                          <a
                            style="margin:1px 4px"
                            class="a-btn"
                            :class="action.btnClass"
                            @click.prevent="action.callback(tr['mf_schcode'])"
                            :title="action.tooltip"
                          >{{action.tooltip}}</a>
                        </span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="consolidated_portfolio_figures.typewise.figures.length > 0">
                    <td class="text-center" colspan="2">Total</td>
                    <td>{{getChecknFixed(consolidated_portfolio_figures.typewise.total)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row mb5" v-if="consolidated_portfolio_figures.typewise.figures.length <= 0">
              <div class="col-md-12">
                <div class="alert alert-danger" role="alert">No data found!</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </card> -->
</template>
<script>
import { VueTabs, VTab } from "vue-nav-tabs";
import "vue-nav-tabs/themes/vue-tabs.scss";
import StarRating from "vue-star-rating";
import Datepicker from "vuejs-datepicker";

import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import { rawMixins } from "../../assets/mixins/rawMixins.js";

export default {
  components: { VueTabs, VTab, StarRating, Datepicker },
  mixins: [commonMixins, rawMixins],
  created() {
    if (!localStorage.getItem("schemeTab")) {
      this.rawDataType = this.rawDataList[this.selRowInd].id;
      // this.selSchemeTab = this.rawDataList[this.selRowInd].value;
      localStorage.setItem("schemeTab", this.rawDataType);
      localStorage.setItem("selSchemeTab", this.selSchemeTab);
      //   this.getRawData();
    } else {
      this.rawDataType = localStorage.getItem("schemeTab");
      this.selSchemeTab = localStorage.getItem("selSchemeTab");
    }
    this.getSchemesList();
    // this.getRawData();
    console.log("Rawtype", this.rawDataType, this.selSchemeTab);
  },
  methods: {
    getRawData() {
      console.log(
        "isApplied",
        this.isApiCalled,
        this.durDate,
        this.getYMDDate(this.durDate)
      );
      if (!this.isApiCalled) {
        // TODO fix isApiCalled issue @MD
        console.log("getRawData selScheme1", this.selScheme1);
        this.isApiCalled = 1;
        this.rawData = [];
        this.tableFields = [];
        this.actions = [];
        this.totalPages = 1;
        let myself = this;
        // let apiUrl = this.rawDataApi + 'consolidated-portfolio' + '/' + this.selScheme.id;
        let apiUrl = this.rawDataApi;
        // if(this.rawDataList[this.selRowInd].isPaginate) {
        //   apiUrl = apiUrl + '?page=' +this.page;
        //   if(this.durDate!=null) {
        //     apiUrl = apiUrl + '&date=' + this.getYMDDate(this.durDate);
        //   }
        // } else {
        //   if(this.durDate!=null) {
        //     apiUrl = apiUrl + '?date=' + this.getYMDDate(this.durDate);
        //   }
        // }
        const filterQueryItems = this.selScheme1.map((item) => item.name);
        console.log("filterQueryItem", filterQueryItems);
        http.post(
          apiUrl + "consolidated-portfolio",
          {
            scheme_names: filterQueryItems,
          },
          (error, response) => {
            this.isApiCalled = 0;
            console.log("Response", this.rawDataType, response.data);
            if (response.status == "success") {
              this.rawData = response.data ? response.data : [];
              this.consolidatedHoldingsList =
                response.data.consolidated_holdings;
              const consolidated_portfolio_figures =
                response.data.consolidated_portfolio_figures;
              this.searchData = this.rawData;
              console.log(this.consolidatedHoldingsList);
              if (this.consolidatedHoldingsList.length > 0) {
                var tableKeys = Object.keys(this.consolidatedHoldingsList[0]);
                tableKeys.forEach((tf, key) => {
                  if (tf != "_id" && tf != "SCH_NAME") {
                    this.tableFields.push({
                      title: tf,
                      name: this.getLabel(tf),
                      rowind: 0,
                      isLink: 0,
                      datatype: tf == "INVDATE" || tf == "date" ? "date" : "",
                      sort_order:
                        tf == "mf_schname" ||
                        tf == "mf_schname" ||
                        tf == "SCH_NAME" ||
                        tf == "sch_name"
                          ? 2
                          : tf == "MF_SCHCODE"
                          ? 2
                          : tf == "TYPE"
                          ? 3
                          : tf == "TYPECODE"
                          ? 4
                          : tf == "IIND_NAME"
                          ? 5
                          : tf == "INVDATE"
                          ? 6
                          : tf == "CO_CODE"
                          ? 7
                          : tf == "CO_NAME"
                          ? 8
                          : tf == "MKTVALUE"
                          ? 9
                          : tf == "NO_SHARES"
                          ? 10
                          : tf == "PERC_HOLD"
                          ? 11
                          : 99,
                    });
                  }
                });
                this.tableFields = this.sorted_fields_asc(
                  this.tableFields,
                  "sort_order"
                );
              }
              console.log("tableFields", this.tableFields);
              console.log("wwwww", consolidated_portfolio_figures.companywise, this.rawData);
              // prepare CompanyWise Table Data
              this.companywiseTableFields = [
                {
                  title: "companywise",
                  name: this.getLabel("CompanyName"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "",
                  sort_order: 1,
                },
                {
                  title: "figures",
                  name: this.getLabel("Figures"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "numeric",
                  sort_order: 2,
                },
              ];
              this.prepareConsolidatedData('companywise', 'companywise', ['companywise', 'figures'], consolidated_portfolio_figures, 'desc');

              // prepare mcaptypewise Table Data
              this.mcaptypewiseTableFields = [
                {
                  title: "capname",
                  name: this.getLabel("CapName"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "",
                  sort_order: 1,
                },
                {
                  title: "figures",
                  name: this.getLabel("Figures"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "numeric",
                  sort_order: 2,
                },
              ];
              this.prepareConsolidatedData('mcaptypewise', 'mcaptypewise', ['capname', 'figures'], consolidated_portfolio_figures);

              // prepare sectorwise Table Data
              this.sectorwiseTableFields = [
                {
                  title: "sectorname",
                  name: this.getLabel("SectorName"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "",
                  sort_order: 1,
                },
                {
                  title: "figures",
                  name: this.getLabel("Figures"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "numeric",
                  sort_order: 2,
                },
              ];
              this.prepareConsolidatedData('sectorwise', 'sectorwise', ['sectorname', 'figures'], consolidated_portfolio_figures, 'desc');

              // prepare ratingwise Table Data
              this.ratingwiseTableFields = [
                {
                  title: "ratingname",
                  name: this.getLabel("RatingName"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "",
                  sort_order: 1,
                },
                {
                  title: "figures",
                  name: this.getLabel("Figures"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "numeric",
                  sort_order: 2,
                },
              ];
              this.prepareConsolidatedData('ratingwise', 'ratingwise', ['ratingname', 'figures'], consolidated_portfolio_figures);


              // prepare typewise Table Data
              this.typewiseTableFields = [
                {
                  title: "typename",
                  name: this.getLabel("TypeName"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "",
                  sort_order: 1,
                },
                {
                  title: "figures",
                  name: this.getLabel("Figures"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "numeric",
                  sort_order: 2,
                },
              ];
              this.prepareConsolidatedData('typewise', 'typewise', ['typename', 'figures'], consolidated_portfolio_figures, 'desc');

              // prepare business rating Table Data
              this.businessRatingTableFields = [
                {
                  title: "business_rating",
                  name: this.getLabel("Business Rating"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "rating",
                  sort_order: 1,
                },
                {
                  title: "figures",
                  name: this.getLabel("% Holding"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "numeric",
                  sort_order: 2,
                },
              ];                
              this.prepareConsolidatedData('business_rating_wise', 'business_rating', ['business_rating', 'figures'], consolidated_portfolio_figures);

              // prepare debt rating Table Data
              this.debtRatingTableFields = [
                {
                  title: "debt_rating",
                  name: this.getLabel("Debt Ratings"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "rating",
                  sort_order: 1,
                },
                {
                  title: "figures",
                  name: this.getLabel("% Holding"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "numeric",
                  sort_order: 2,
                },
              ];                
              this.prepareConsolidatedData('p11_debt_rating_wise', 'debt_rating', ['debt_rating', 'figures'], consolidated_portfolio_figures);

              // prepare valuation rating Table Data
              this.valuationRatingTableFields = [
                {
                  title: "valuation_rating",
                  name: this.getLabel("Valuation Rating"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "rating",
                  sort_order: 1,
                },
                {
                  title: "figures",
                  name: this.getLabel("% Holding"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "numeric",
                  sort_order: 2,
                },
              ];                
              this.prepareConsolidatedData('valuation_rating_wise', 'valuation_rating', ['valuation_rating', 'figures'], consolidated_portfolio_figures);  
              
              // prepare Quarterly rating Table Data
              this.quarterlyRatingTableFields = [
                {
                  title: "quarterly_rating",
                  name: this.getLabel("Quarterly Ratings"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "rating",
                  sort_order: 1,
                },
                {
                  title: "figures",
                  name: this.getLabel("% Holding"),
                  rowind: 0,
                  isLink: 0,
                  datatype: "numeric",
                  sort_order: 2,
                },
              ];                
              this.prepareConsolidatedData('quarterly_rating_wise', 'quarterly_rating', ['quarterly_rating', 'figures'], consolidated_portfolio_figures);
           
              // preparing top 3 exposure data for all portfolio items
              this.prepareConsolidatedData('business_rating_wise', 'business_rating', ['business_rating', 'figures'], consolidated_portfolio_figures.top_3_exposures, '', 'top3');
              this.prepareConsolidatedData('quarterly_rating_wise', 'quarterly_rating', ['quarterly_rating', 'figures'], consolidated_portfolio_figures.top_3_exposures, '', 'top3');
              this.prepareConsolidatedData('valuation_rating_wise', 'valuation_rating', ['valuation_rating', 'figures'], consolidated_portfolio_figures.top_3_exposures, '', 'top3');    
              this.prepareConsolidatedData('p11_debt_rating_wise', 'debt_rating', ['debt_rating', 'figures'], consolidated_portfolio_figures.top_3_exposures, '', 'top3');
              
              this.prepareConsolidatedData('typewise', 'typewise', ['typename', 'figures'], consolidated_portfolio_figures.top_3_exposures, '', 'top3');
              this.prepareConsolidatedData('ratingwise', 'ratingwise', ['ratingname', 'figures'], consolidated_portfolio_figures.top_3_exposures, '', 'top3');
              this.prepareConsolidatedData('sectorwise', 'sectorwise', ['sectorname', 'figures'], consolidated_portfolio_figures.top_3_exposures, '', 'top3');
              this.prepareConsolidatedData('mcaptypewise', 'mcaptypewise', ['capname', 'figures'], consolidated_portfolio_figures.top_3_exposures, '', 'top3');
              this.prepareConsolidatedData('companywise', 'companywise', ['companywise', 'figures'], consolidated_portfolio_figures.top_3_exposures, '', 'top3');
           }
            this.isApiCalled = 0;
          }
        );
      }
    },
    prepareConsolidatedData(apiDataKey, localType, colKeys, portfolioFiguresData, sortOrder="", type="") {
      let typeData = [];
      if(type=='top3') {
        for (const [key, value] of Object.entries(
              portfolioFiguresData[apiDataKey]
            )) {
              const data = {
                [colKeys[0]]: key,
                [colKeys[1]]: value,
              };
              typeData.push(data);
        }
        if(sortOrder) {
          if(sortOrder == 'asc') {
            typeData = typeData.sort((a, b) => {
              return a.colKeys[1] - b.colKeys[1];
            })
          } else if(sortOrder == 'desc') {
            typeData = typeData.sort((a, b) => {
              return b.colKeys[1] - a.colKeys[1];
            })
          }
        }
        this.consolidated_top_3_exposures[localType].figures = typeData;
        this.consolidated_top_3_exposures[localType].total = typeData.reduce((acc, curr) => {
         return acc+curr[colKeys[1]];
        }, 0);
                
      } else {
          for (const [key, value] of Object.entries(
              portfolioFiguresData[apiDataKey].figures
            )) {
              const data = {
                [colKeys[0]]: key,
                [colKeys[1]]: value,
              };
              typeData.push(data);
          }
          if(sortOrder) {
            if(sortOrder == 'asc') {
              typeData = typeData.sort((a, b) => {
                return a[colKeys[1]] - b[colKeys[1]];
              })
            } else if(sortOrder == 'desc') {
              typeData = typeData.sort((a, b) => {
                return b[colKeys[1]] - a[colKeys[1]];
              })
            }
          }
          if(localType == 'ratingwise') {
            let ratingData = [];
            typeData.forEach((indVal, indKey) => {
              ratingData.push({ 
                [colKeys[0]]: indVal[colKeys[0]],
                [colKeys[1]]: indVal[colKeys[1]],
                sort_order: (indVal[colKeys[0]] === 'AAA') ? 0 : (indVal[colKeys[0]] === 'AA+') ? 1 : (indVal[colKeys[0]] === 'AA') ? 2: (indVal[colKeys[0]] === 'AA-')? 3: (indVal[colKeys[0]] === 'A+')? 4: (indVal[colKeys[0]] === 'EQUITY')? 5 : 6
              });
            });
            typeData = ratingData.sort((a,b) => {
              return a.sort_order - b.sort_order
            })
          }
          this.consolidated_portfolio_figures[localType].figures = typeData;
          this.consolidated_portfolio_figures[localType].total =
                portfolioFiguresData[apiDataKey].total;
      }
    },
    getTableFieldByType(consolidatedType) {
      if(consolidatedType == 'companywise') {
        return this.companywiseTableFields;
      } else if(consolidatedType == 'mcaptypewise') {
        return this.mcaptypewiseTableFields;
      } else if(consolidatedType == 'sectorwise') {
        return this.sectorwiseTableFields;
      } else if(consolidatedType == 'ratingwise') {
        return this.ratingwiseTableFields;
      } else if(consolidatedType == 'typewise') {
        return this.typewiseTableFields;
      } else if(consolidatedType == 'business_rating') {
        return this.businessRatingTableFields;
      } else if(consolidatedType == 'debt_rating') {
        return this.debtRatingTableFields;
      } else if(consolidatedType == 'valuation_rating') {
        return this.valuationRatingTableFields;
      } else if(consolidatedType == 'quarterly_rating') {
        return this.quarterlyRatingTableFields;
      }
    },
    getTabData(tabIndex, newTab, oldTab) {
      console.log(this.selRowInd, tabIndex, this.selRowInd != tabIndex);
      console.log(
        "TabChange",
        this.selRowInd,
        tabIndex,
        newTab,
        oldTab,
        this.rawDataList
      );
      if (this.selRowInd != tabIndex) {
        this.clearPagination();
        this.ratings.subFields = [];
        this.rawDataList[this.selRowInd].open = false;
        this.selRowInd = tabIndex;
        this.rawDataType = this.rawDataList[tabIndex].id;
        this.selSchemeTab = this.rawDataList[tabIndex].value;
        localStorage.setItem("schemeTab", this.rawDataType);
        localStorage.setItem("selSchemeTab", this.selSchemeTab);
        this.resetFilter();
        this.getRawData();
      } else if (this.selRowInd == tabIndex) {
        this.selRowInd = tabIndex;
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.prevDisabled = 0;
      this.fillTable();
    },
    fillTable() {
      this.page = this.pageToLoad;
      if (this.pageToLoad == this.totalPages) {
        this.nextDisabled = 1;
      } else {
        this.nextDisabled = 0;
      }
      if (this.pageToLoad == 1) {
        this.prevDisabled = 1;
      } else {
        this.prevDisabled = 0;
      }
      this.current_page = this.pageToLoad;
      this.getRawData();
    },
    clearPagination() {
      this.page = 1;
      this.current_page = 1;
      this.pageToLoad = 1;
      this.totalPages = 1;
      this.prevDisabled = 1;
      this.nextDisabled = 0;
      this.pages = [];
    },
    search() {
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.searchData.filter((rd) => {
          return (
            rd.nameamc.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.LNAME
              ? rd.LNAME.toLowerCase().includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    },
    filterSchemes() {
      console.log("filterSchemes called");
      console.log("selScheme1 ", this.selScheme1);
      if (this.selScheme1 && this.selScheme1.length > 0) {
        this.isFiltered = true;
        this.getRawData();
      }
    },
    resetFilter() {
      this.isFiltered = false;
      if (this.selScheme1 && this.selScheme1.length > 0) {
        this.selScheme1 = [];
        this.getRawData();
      }
    },
    getSchemesList() {
      let _this = this;
      http.get("mutual-funds/schemes?onlyCodeAndNames=1", {}, function (
        error,
        response
      ) {
        if (response.status == "success") {
          console.log("schemeList =>>>>>", response.data);
          var schemeList = response.data;
          var uniqueFundManagers = [];
          if (schemeList.length > 0) {
            schemeList.forEach((scheme) => {
              //   console.log(scheme);
              _this.schemeList.push({
                id: scheme.mf_schcode,
                name: scheme.sch_name,
              });
              if (
                _this.$route.params.id &&
                _this.$route.params.id == scheme.mf_schcode
              ) {
                _this.selScheme = {
                  id: scheme.mf_schcode,
                  name: scheme.sch_name,
                };
                localStorage.setItem(
                  "selscheme",
                  JSON.stringify(_this.selScheme)
                );
              }
            });
            _this.schemeList = _this.sorted_fields_asc(_this.schemeList, "id");
            if (!localStorage.getItem("selscheme")) {
              _this.selScheme = _this.schemeList[0];
              localStorage.setItem(
                "selscheme",
                JSON.stringify(_this.selScheme)
              );
            } else {
              _this.selScheme = JSON.parse(localStorage.getItem("selscheme"));
            }
            console.log(
              "Selected Scheme",
              typeof _this.selScheme,
              _this.schemeList
            );
          }
        }
      });
    },
    getSchemeRawData() {
      console.log("Get getSchemeRawData", this.selScheme1);
      if (this.selScheme1.length < 0 && this.isFiltered) {
        // this.isFiltered = false;
      }
    },
    getDateData(e) {
      console.log("Date Selected", e);
      this.durDate = e;
      this.filterSchemes();
    },
  },
  data() {
    return {
      durDate: null,
      // durDate: new Date().setDate(new Date().getDate() - 1),
      disabledDates: {
        from: new Date(new Date().setDate(new Date().getDate() - 1)),
      },
      selSchemeTab: "",
      tableFields: [],
      companywiseTableFields: [],
      mcaptypewiseTableFields: [],
      sectorwiseTableFields: [],
      ratingwiseTableFields: [],
      typewiseTableFields: [],
      schemeReturnsFields: [],
      schemeReturnsRows: [],
      searchText: "",
      selScheme: null,
      selScheme1: [],
      isFiltered: false,
      consolidatedHoldingsList: [],
      consolidated_portfolio_figures: {
        companywise: { figures: [], total: 0 },
        mcaptypewise: { figures: [], total: 0 },
        sectorwise: { figures: [], total: 0 },
        ratingwise: { figures: [], total: 0 },
        typewise: { figures: [], total: 0 },
        business_rating: { figures: [], total: 0 },
        debt_rating: { figures: [], total: 0 },
        valuation_rating: { figures: [], total: 0 },
        quarterly_rating: { figures: [], total: 0 },
        overall_ratings: {},
        credit_ratings_wise: []
      },
      consolidated_top_3_exposures: {
        companywise: { tableHeading: 'Top 3 Company Wise Exposure', figures: [], total: 0 },
        mcaptypewise: { tableHeading: 'Top 3 Mcap Type Wise Exposure', figures: [], total: 0 },
        sectorwise: { tableHeading: 'Top 3 Sector Wise Exposure', figures: [], total: 0 },
        ratingwise: { tableHeading: 'Top 3 Rating Wise Exposure', figures: [], total: 0 },
        typewise: { tableHeading: 'Top 3 Type Wise Exposure', figures: [], total: 0 },
        business_rating: { tableHeading: 'Top 3 Business Rating Exposure', figures: [], total: 0 },
        debt_rating: { tableHeading: 'Top 3 Debt Rating Exposure', figures: [], total: 0 },
        valuation_rating: { tableHeading: 'Top 3 Valuation Rating Exposure', figures: [], total: 0 },
        quarterly_rating: { tableHeading: 'Top 3 Quarterly Rating Exposure', figures: [], total: 0 },
      },
      creditRatingsKeys: [
        {
          title: 'TYPE',
          name: 'Type',
          isLink: 0,
          datatype: 'string',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        // {
        //   title: 'name',
        //   name: this.getLabel('name'),
        //   isLink: 0,
        //   datatype: 'string',
        //   sort_order: 2,
        //   sort: 0,
        //   isSortable: 0
        // },,
        {
          title: 'consol_perc_hldg',
          name: this.getLabel('% Holdings'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 10,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'consol_perc_hldg_adj',
          name: this.getLabel('Adj. % Holdings'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 11,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'business_rating',
          name: this.getLabel('business_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 4,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'business_rating_adj',
          name: this.getLabel('adj_business_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 7,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'valuation_rating',
          name: this.getLabel('valuation_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 5,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'valuation_rating_adj',
          name: this.getLabel('adj_valuation_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 8,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'quarterly_rating',
          name: this.getLabel('quarterly_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 6,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'quarterly_rating_adj',
          name: this.getLabel('adj_quarterly_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 9,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'debt_others_rating',
          name: this.getLabel('Debt_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 6,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'debt_others_rating_adj',
          name: this.getLabel('adj_debt_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 9,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'overall_rating',
          name: this.getLabel('Overall Rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 10,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'overall_rating_adj',
          name: this.getLabel('adj_overall_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 11,
          sort: 0,
          isSortable: 1
        }
      ],
      businessRatingTableFields: [],
      debtRatingTableFields: [],
      valuationRatingTableFields: [],
      quarterlyRatingTableFields: [],
      schemeList: [],
      scheme_name: "",
      category: "",
      invType: "",
      actions: [],
      isApiCalled: 0,
      param: "scheme-master-info",
      currentComp: "",
      dateFilterTabs: [
        "scheme-aum",
        "whats-in-out",
        "scheme-asset-allocation",
        "dividend-details",
        "scheme-ratios",
        "scheme-returns",
        "scheme-nav-historical",
        "sector-historical",
        "analysis",
        "analysis-sum",
        "category-wise-returns",
        "scheme-holdings",
      ],
      rawDataList: [
        // { id: "scheme-master-info", value: "Scheme Master Info", open: false, items: {}, isPaginate: 0 },
        {
          id: "scheme-holdings",
          value: "Holdings",
          open: false,
          items: {},
          isPaginate: 0,
        },
        {
          id: "scheme-ratios",
          value: "Scheme Ratios",
          open: false,
          items: {},
          isPaginate: 0,
        },
        {
          id: "scheme-profile-exp-ratio",
          value: "Profile Exp Ratios",
          open: false,
          items: {},
          isPaginate: 0,
        },
        {
          id: "analysis",
          value: "Analysis",
          open: false,
          items: {},
          isPaginate: 0,
        },
        {
          id: "analysis-sum",
          value: "Analysis Sum",
          open: false,
          items: {},
          isPaginate: 0,
        },
        {
          id: "scheme-returns",
          value: "Scheme Returns",
          open: false,
          items: {},
          isPaginate: 0,
        },
        {
          id: "scheme-nav-latest",
          value: "Scheme NAV Latest",
          open: false,
          items: {},
          isPaginate: 1,
        },
        {
          id: "scheme-nav-historical",
          value: "Scheme NAV Historical",
          open: false,
          items: {},
          isPaginate: 1,
        },
        {
          id: "sector-historical",
          value: "Sector Historical",
          open: false,
          items: {},
          isPaginate: 1,
        },
        {
          id: "dividend-details",
          value: "Dividend Details",
          open: false,
          items: {},
          isPaginate: 1,
        },
        {
          id: "sip-dates",
          value: "SIP Dates",
          open: false,
          items: {},
          isPaginate: 1,
        },
        {
          id: "scheme-asset-allocation",
          value: "Scheme Asset Allocation",
          open: false,
          items: {},
          isPaginate: 1,
        },
        {
          id: "scheme-aum",
          value: "Scheme AUM",
          open: false,
          items: {},
          isPaginate: 1,
        },
        {
          id: "whats-in-out",
          value: "What In-Out",
          open: false,
          items: {},
          isPaginate: 1,
        },
      ],
      rawDataType: "fund-houses",
      rawDataApi: "mutual-funds/",
      rawData: [],
      sum: {},
      fillableData: [],
      selRowInd: 0,
      page: 1,
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      perPage: 200,

      ratings: {
        title: "ratings",
        name: "Ratings",
        datatype: "numeric",
        sort_order: 51,
        sort: 0,
        isSortable: 1,
        subFields: [],
      },
      industryKeys: [
        { title: "name", name: "Sector" },
        { title: "value", name: "% Holding" },
      ],
      mcapKeys: [],
      typewiseKeys: [],
      psumratingwiseKeys: [],
      top3exposuresKeys: [],
      top3industryKeys: [],
      businessRatings: [],
      businessRatingKeys: [7, 6, 5, 4, 3, 2, 1],
      valuationRatingKeys: [5, 4, 3, 2, 1],
      valuationRatings: [],
      qtrRatingKeys: [5, 4, 3, 2, 1],
      qtrRatings: [],
      debtRatingKeys: [7, 6, 5, 4, 3, 2, 1],
      debtRatings: [],
      overAllratingKeys: [ 
        { title: 'overall_business_rating', name: 'Business Rating'},
        { title: 'overall_valuation_rating', name: 'Valuation Rating'},
        { title: 'overall_quarterly_rating', name: 'Quarterly Rating'},
        { title: 'overall_debt_others_rating', name: 'Debt & Others Rating'},
        { title: 'overall_equity_rating', name: 'Equity Rating'},
        { title: 'overall_scheme_rating', name: 'Scheme Rating'},
        { title: 'overall_weighted_scheme_rating', name: 'Weighted Scheme Rating'}
        ]
    };
  },
  computed: {
    // mfHoldingData: function() {
    //   return this.rawData.filter(function(row, index) {
    //     return index !== "_id" && index !== "co_code";
    //   });
    // },
    // keyFinancialRatios: function(){
    //   return (this.rawData.length > 0 && this.rawData[0]['keyfinancialratiolist'])? this.rawData[0]['keyfinancialratiolist']: [];
    // }
  },
};
</script>
<style>
form .col-md-3 {
  width: 40%;
}
.table td {
  padding: 5px 10px 5px 10px;
}
span.success,
td span.success {
  color: #28a745;
}
span.error,
td span.error {
  color: #dc3545;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/portfolio.vue